import { createFileRoute, useNavigate } from '@tanstack/react-router'
// Register the contact panel plus the company panel the contacts grid
// cross-references, so the company opens in place on the contacts list.
import '../../../modules/companies/register-panels'
import '../../../modules/contacts/register-panels'
import { ContactsView } from '../../../modules/contacts/contacts-view'
import { contactsSearchSchema } from '../../../modules/contacts/lib/search-schema'

/** The Contacts grid. Selection + filter + panel state live in the URL. */
export const Route = createFileRoute('/_authed/contacts/')({
  validateSearch: contactsSearchSchema,
  component: ContactsRoute,
})

function ContactsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <ContactsView
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => {
            const next: Record<string, unknown> = { ...prev, ...patch }
            for (const [k, v] of Object.entries(next)) {
              if (v == null || (Array.isArray(v) && v.length === 0) || v === '') delete next[k]
            }
            return next
          }) as never,
          replace: true,
        })
      }
    />
  )
}
